import React, { useEffect, useState } from "react";
import "./App.css";
import { AuthenticateDocument } from "./utils/AuthenticateDocument";
import MainLayout from "./components/MainLayout";
import External from "./components/ExternalUser";
import { slideAction } from "./store/slideSlice";
import { useDispatch } from "react-redux";

function App({ isExternal = false, isTemplate = false }) {
  const dispatch = useDispatch();
  const [isAuthenticating, setIsAuthenticating] = useState(true);

  useEffect(() => {
    dispatch(slideAction.setIsTemplateDocument(isTemplate));
  }, []);

  if (isExternal) {
    return <External />;
  }
  else {
    if (isAuthenticating) { // isAuthenticating
      return <AuthenticateDocument setIsLoading={setIsAuthenticating} />
    }
    else {
      return <MainLayout />;
    }
  }

}

export default App;
